/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Tue Jan 07 2025
 **/

export enum PEN_TYPE {
	PEN = "pen",
	ERASER = "eraser",
	MARKER = "marker"
}

export enum OBJECT_TYPE {
	FREE_LINE = "freeline",
	LINE = "line",
	ARROW = "arrow",
	RECT = "rect",
	CIRCLE = "circle",
	ELLIPSE = "ellipse",
	EMOJI = "emoji",
	IMAGE = "image",
	TEXT = "text",
	EMPTY = "empty"
}

export enum MODE {
	POINTING = "pointer",
	DRAWING = "drawing",
	CURSOR = "cursor"
}

export enum DRAWING_STATE {
	START,
	DRAWING,
	END
}
